export const decryptTool = {
  decryptKey: "2019ysapp7527",
  cachedBlobs: {},
  /**
   * @description 图片解密
   * @param url 需要解密的url
   * @returns  解密过后的图片链接
   */
  async imgDecypt(url) {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then((r) => r.arrayBuffer())
        .then((rb) => {
          const blobUrl = this.imgEncrypt(rb);
          resolve(blobUrl);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  /**
   * 图片解密
   * @param buffer buffer
   * @returns
   */
  imgEncrypt(buffer) {
    const bytes = new Uint8Array(buffer);
    const encoder = new TextEncoder();
    const KEY = encoder.encode(this.decryptKey);
    for (let i = 0; i < 100; i++) {
      bytes[i] ^= KEY[i % KEY.length];
    }
    const blob = new Blob([bytes], {
      type: "image/png",
    });
    const url = URL.createObjectURL(blob);
    return url;
  },
};
